import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/system';
import BottomNavigation from '@mui/material/BottomNavigation';
import Box from '@mui/material/Box';
import { isMobileMedia } from 'bento-ordering/utils/media';
import { getPageBackgroundColor } from 'styles/helpers/getThemeStyles';
import { LayoutContext } from 'bento-ordering/context/LayoutContext';

const StyledBottomNavigation = styled(BottomNavigation)(({ theme }) => {
  return {
    backgroundColor: getPageBackgroundColor(theme),
    flexDirection: 'column'
  };
});

const MobileFooter = ({ children }) => {
  const bottomNavComponentRef = useRef(null);
  const { setBottomNavHeight } = React.useContext(LayoutContext);

  useEffect(() => {
    if (bottomNavComponentRef.current) {
      const height = bottomNavComponentRef.current.offsetHeight;
      setBottomNavHeight(height);
    }

    return () => {
      setBottomNavHeight(0);
    };
  }, [children, setBottomNavHeight]);

  if (!isMobileMedia()) {
    return null;
  }

  return (
    <Box mt={4}>
      <StyledBottomNavigation ref={bottomNavComponentRef}>
        {children}
      </StyledBottomNavigation>
    </Box>
  );
};

MobileFooter.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.func,
    PropTypes.array
  ])
};

export default MobileFooter;
